import React from 'react'
import ContactComponent from '../../components/contact/contact'
import Header from '../../components/header/Header'
// import Footer from '../../components/footer/footer'
import { Helmet } from 'react-helmet'

export default function Contact() {
  return (
    <>
    <Helmet>
            <title>Contact — Gopal Goyal</title>
            <meta name='description'
            content='Get in touch with Gopal Goyal — AI & Full-Stack Engineer. Reach out via email, LinkedIn, or GitHub.'/>
            <meta name='keywords' content='contact Gopal Goyal, Gopal Goyal email, Gopal Goyal LinkedIn'/>
          </Helmet>
    <Header/>
    <ContactComponent/>
    {/* <Footer/> */}
    </>
  )
}
